import { useLocation, useNavigate } from 'react-router'

export type UseNavigatorResult = (
  url: string,
  replace?: boolean,
  preserveQs?: boolean,
  scroll?: boolean,
  state?: Record<string, unknown>,
) => void
function useNavigator(): UseNavigatorResult {
  const { search } = useLocation()

  const navigate = useNavigate()

  return (
    url: string,
    replace = false,
    preserveQs = false,
    scroll = true,
    state?: Record<string, unknown>,
  ) => {
    const targetUrl = preserveQs ? url + search : url
    navigate(targetUrl, {
      replace,
      state,
    })

    if (scroll) {
      window.scrollTo({ behavior: 'smooth', top: 0 })
    }
  }
}

export default useNavigator
